module.exports = __webpack_public_path__ + "resources/icon-letter-back.febfd5e6f6be0610.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/game-lottery/component/lottery-dialog-rolling/img/icon-letter-back.png
// module id = 824
// module chunks = 0 1